import BigNumberJs from "bignumber.js";

export function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function formatCryptoDecimals(
  formattedValue: string,
  maxDecimals = 6
): string {
  return new BigNumberJs(formattedValue)
    .decimalPlaces(maxDecimals, BigNumberJs.ROUND_UP)
    .toString();
}
